'use client'

import { createContext, useContext } from 'react'

type LocaleContextValue = {
  dialog: {
    close: string
  }
}

export const LocaleContext = createContext<LocaleContextValue | null>(null)

export const useLocaleContext = (): LocaleContextValue => {
  const localeContext = useContext(LocaleContext)

  if (localeContext === null) {
    throw new Error('useLocaleContext must be used within a LocaleProvider')
  }

  return localeContext
}
